export default `
  mutation toggleCardReaction($workflowId: String!, $input: CardReactionInput) {
    toggleCardReaction(workflowId: $workflowId, input: $input) {
      workflowId
      cardId
      direction
      createdAt
      user {
        id
        firstname
        lastname
      }
    }
  }
`
